export default __webpack_public_path__ + "static/media/Team.7c978257.png";